// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/index.style.scss
// module id = 1326
// module chunks = 0